module.exports = __webpack_public_path__ + "img/mevn.559871ac.png";